export default __webpack_public_path__ + "media/images/favicon/android-chrome-192x192-b462280aadf552ff6be9ae92bc8fd064.png";